import { gql } from '@apollo/client';

export const QUERY_LIST_AI_CONTEXT = gql`
  query ListAIContext(
    $search: String
    $municipality_code: String
    $category: String
    $limit: Int = 50
    $offset: Int = 0
  ) {
    listAIContext(
      search: $search
      municipality_code: $municipality_code
      category: $category
      limit: $limit
      offset: $offset
    ) {
      id
      uploaded_file {
        id
        filename
        original_name
        file_url
        file_size
        mime_type
        category
        municipality_code
        created_at
      }
      vector_data {
        total_chunks
        chunks_processed
        title
        category
        municipality_code
      }
      metadata
      created_at
    }
  }
`;

export const QUERY_GET_CONVERSATIONS = gql`
  query GetConversations($input: GetConversationsInput!) {
    getConversations(input: $input) {
      conversations {
        id
        municipality_code
        user_id
        title
        created_at
        updated_at
        messages {
          id
          conversation_id
          role
          content
          created_at
        }
      }
      total
    }
  }
`;

export const QUERY_GET_CONVERSATION = gql`
  query GetConversation($conversation_id: String!) {
    getConversation(conversation_id: $conversation_id) {
      id
      municipality_code
      user_id
      title
      created_at
      updated_at
      messages {
        id
        conversation_id
        role
        content
        created_at
      }
    }
  }
`;

export const QUERY_GET_CONVERSATION_HISTORY = gql`
  query GetConversationHistory($conversation_id: String!) {
    getConversationHistory(conversation_id: $conversation_id) {
      id
      conversation_id
      role
      content
      created_at
    }
  }
`;

export const QUERY_SEARCH_CITY_KNOWLEDGE = gql`
  query SearchCityKnowledge($query: String!, $municipality_code: String, $limit: Float = 5) {
    searchCityKnowledge(query: $query, municipality_code: $municipality_code, limit: $limit) {
      id
      title
      content
      category
      municipality_code
      created_at
      similarity
    }
  }
`;

export const QUERY_GET_CITY_KNOWLEDGE = gql`
  query GetCityKnowledge($input: GetCityKnowledgeInput!) {
    getCityKnowledge(input: $input) {
      id
      municipality_code
      title
      content
      category
      created_at
      municipality {
        municipality_code
        name_municipality
        name_uf
        sigla_uf
      }
    }
  }
`;

export const QUERY_GET_AVAILABLE_CITIES = gql`
  query GetAvailableCities($limit: Float = 50, $offset: Float = 0) {
    getAvailableCities(limit: $limit, offset: $offset) {
      municipality_code
      name_municipality
      name_uf
      sigla_uf
    }
  }
`;

export const QUERY_SEARCH_MUNICIPALITIES = gql`
  query SearchMunicipalities($query: String, $limit: Float = 20, $offset: Float = 0) {
    getAvailableCities(query: $query, limit: $limit, offset: $offset) {
      municipality_code
      name_municipality
      name_uf
      sigla_uf
    }
  }
`;

export const QUERY_LIST_UPLOADED_FILES = gql`
  query ListUploadedFiles(
    $municipality_code: String
    $category: String
    $search: String
    $limit: Int = 10
    $offset: Int = 0
  ) {
    listUploadedFiles(
      municipality_code: $municipality_code
      category: $category
      search: $search
      limit: $limit
      offset: $offset
    ) {
      id
      filename
      original_name
      file_url
      file_size
      mime_type
      category
      municipality_code
      created_at
    }
  }
`;

export const QUERY_GET_KNOWLEDGE_BY_FILE = gql`
  query GetKnowledgeByFile($uploaded_file_id: String!, $limit: Int = 10, $offset: Int = 0) {
    getKnowledgeByFile(uploaded_file_id: $uploaded_file_id, limit: $limit, offset: $offset) {
      id
      title
      category
      type
      content
      created_at
    }
  }
`;
